/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {http} from '@helpers/common'
import {DefaultComponentProps} from '@interface/common'


/**
 * App configuration
 */
import app from '@config/application'

/**
 * Components
 */
import Button from '@components/button'

/**
 * Images
 */
import Close from '@assets/images/close.png'


/**
 * Add organization
 */
export default pure(({user, store, modal}: DefaultComponentProps) => {
  const state = store.useLocalState({
    name: null,
    email: null,
    industry: app.industries[0],
  })

  
  function submit(e: any) {
    e.preventDefault()
    http.post('/organizations', {
      data: {
        org: {
          type: state.industry,
          name: state.name,
          email: state.email,
        },
        user: {
          email: user.email
        },
        ref: 'panel'
      }
    })
    .then(({status, result}) => {
      if(status === 201) {
        modal.close({organization: result})
      }
    })
    .catch(e => console.log(e))
  }

  return (
    <div
      id="add-organization"
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <div className="head">
        <h2>Add Organization</h2>
        <span
          className="close"
          onClick={modal.close}>
          <img alt="Close" src={Close}/>
        </span>
      </div>
      <form onSubmit={submit}>
        <div className="fields">
          <div className="field" style={{marginBottom: 10}}>
            <label>Organization Name</label>
            <input type="text" onChange={(e) => state.set({name: e.target.value})} required/>
          </div>
          <div className="field" style={{marginBottom: 10}}>
            <label>Industry</label>
            <select
              onChange={(e) => {
                state.set({industry: e.target.value})
              }}>
              {app.industries.map((item) => {
                return (
                  <option value={item}>{item}</option>
                )
              })}
            </select>
          </div>
          <div className="field">
            <label>Email Address</label>
            <input type="email" onChange={(e) => state.set({email: e.target.value})} required/>
          </div>
        </div>
        <div className="action">
          <Button
            label={'Save'}
            style={{
              width: '100%'
            }}
            className={'button-3'}
          />
        </div>
      </form>
    </div>
  )
})